<template>
  <div class="wapper">
    <div class="newsSuccess mid-width clearfix">
      <dl class="slideBar">
        <dt>典型案例</dt>
        <dd v-for="item in newsSuccessSubList" 
          :key="item.index" 
          @click="getSuccessList(1, item.id, 'nav')"
          :class="{'active': isActive === item.id}"
        >• {{item.name}}</dd>
      </dl>
      <div class="content">
        <img src="./img1.jpg" width="100%">
        <ul class="caseList">
          <li  v-for="(item, index) in newsSuccessList" :key="index" @click="getNewDetail(item.id)" class="clearfix">
            <img :src="item.imageUrl">
            <div class="caseRight">
              <div class="title">{{item.title}}</div>
              <div>{{item.introduction}}</div>
              <div class="bottom clearfix">
                <span class="floatLeft">{{item.createTimeStr}}</span>
                <span class="floatRight">阅读{{item.viewCount}}</span>
              </div>
            </div>
          </li>
        </ul>
        <button class="loadMore btn" @click="loadMore" v-show="currentPage !== totalPage">{{moreText}}</button>
      </div>

    </div>
  </div>

</template>

<script>
import Api from '@/common/api/api'
export default ({
  data() {
    return {
      newsSuccessSubList: [],
      newsSuccessList: [],
      isActive: '',
      currentPage: 1,
      totalPage: 0,
      isClick: false,
      moreText: '加载更多',
      newDetail: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Api.getCmscontentsubject({
        page: 1,
        limit: 20,
        parentId: 1
      }).then((response) => {
        console.log(response)
        if (response.data.code === 0) {
          this.newsSuccessSubList = response.data.page.list
          if (this.$route.query.id) {
            this.getSuccessList(1, this.$route.query.id)
            this.isActive = this.$route.query.id
          } else {
            // this.getSuccessList(1, this.newsSuccessSubList[0].id)
            this.getSuccessList(1)
            // this.isActive = this.newsSuccessSubList[0].id
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
    },
    getSuccessList(page, e, c) {
      this.currentPage = page
      this.isActive = e
      if (c === 'nav') {
        this.newsSuccessList = []
      }
      Api.getCmscontent({
        page: this.currentPage,
        limit: 5,
        subjectId: e,
        subjectParentId: 1
      }).then((response) => {
        if (response.data.code === 0) {
          if (response.data.page.list.length > 0) {
            response.data.page.list.forEach(element => {
              this.newsSuccessList.push(element)
            })
            this.currentPage = response.data.page.currPage
            this.totalPage = response.data.page.totalPage
          } else {
            this.totalPage = this.currentPage
          }
        }
        this.moreText = '加载更多'
        this.isClick = false
      })
      .catch((error) => {
        console.log(error);
      })
    },
    getNewDetail(e) {
      this.$router.push({
        path:'/newsDetail',
        query: {
          id: e,
          parentId: 1
        }
      })
    },
    
    loadMore() {
      if(!this.isClick) {
        this.isClick = true
        this.currentPage++
        this.moreText = '加载中'
        this.getSuccessList(this.currentPage++,this.isActive)
      }
      
    }
  }
})
</script>
<style lang="scss" scoped>
  @import '~@/common/css/common';
  @import '~@/common/css/news_success';
</style>



// WEBPACK FOOTER //
// src/components/news/successCase.vue